import { Box } from "@mui/material"
import { ItemLightDto } from "../../core/items/ItemDataTypes"
import { DbKokiriSwordItem } from "../inventory/items/KokiriSwordItem"
import { DbBiggoronSwordItem } from "../inventory/items/BiggoronSwordItem"
import { DbLightMedallionItem } from "../inventory/medallions/LightMedallionItem"
import { DbKokiriEmeraldItem } from "../inventory/medallions/KokiriEmeraldItem"
import { DbGoronRubyItem } from "../inventory/medallions/GoronRubyItem"
import { DbZoraSapphireItem } from "../inventory/medallions/ZoraSapphireItem"
import { DbForestMedallionItem } from "../inventory/medallions/ForestMedallionItem"
import { DbFireMedallionItem } from "../inventory/medallions/FireMedallionItem"
import { DbWaterMedallionItem } from "../inventory/medallions/WaterMedallionItem"
import { DbShadowMedallionItem } from "../inventory/medallions/ShadowMedallionItem"
import { DbSpiritMedallionItem } from "../inventory/medallions/SpiritMedallionItem"
import { DbSlingshotItem } from "../inventory/items/SlingshotItem"
import { DbBowItem } from "../inventory/items/BowItem"
import { DbBoomrangItem } from "../inventory/items/BoomrangItem"
import { DbHookshotItem } from "../inventory/items/HookshotItem"
import { DbBombItem } from "../inventory/items/BombItem"
import { DbMegatonHammerItem } from "../inventory/items/MegatonHammerItem"
import { DbFireArrowItem } from "../inventory/items/FireArrowItem"
import { DbLightArrowItem } from "../inventory/items/LightArrowItem"
import { DbIceArrowItem } from "../inventory/items/IceArrowItem"
import { DbDinsFireItem } from "../inventory/items/DinsFireItem"
import { DbFaroresWindItem } from "../inventory/items/FaroresWindItem"
import { DbRutoLetterItem } from "../inventory/items/RutoLetterBottle"
import { DbStrengthItem } from "../inventory/items/StrengthItem"
import { DbScaleItem } from "../inventory/items/ScaleItem"
import { DbLensOfTruthItem } from "../inventory/items/LensOfTruthItem"
import { DbBombchusItem } from "../inventory/items/BombchusItem"
import { DbGoronTunicItem } from "../inventory/items/GoronTunicItem"
import { DbZoraTunicItem } from "../inventory/items/ZoraTunicItem"
import { DbIronBootsItem } from "../inventory/items/IronBootsItem"
import { DbHoverBootsItem } from "../inventory/items/HoverBootsItem"
import { DbHylianShieldItem } from "../inventory/items/HylianShieldItem"
import { DbMirrorShieldItem } from "../inventory/items/MirrorShieldItem"
import { DbEmptyBottleItem } from "../inventory/items/EmptyBottle"
import { DbAdultSequenceItem } from "../inventory/items/AdultSequenceItem"
import { DbWalletItem } from "../inventory/items/WalletItem"
import { DbGerudoCardItem } from "../inventory/items/GerudoCardItem"
import { DbMagicItem } from "../inventory/items/MagicItem"
import { DbMagicBeansItem } from "../inventory/items/MagicBeansItem"

export interface CommentaryPlayerTrackerProps {
    items?: Array<ItemLightDto>
    updateItem?: (v: ItemLightDto) => void
}


const CommentaryPlayerTracker = (props: CommentaryPlayerTrackerProps) => {


    return <Box position={"relative"}>
        <Box position={"absolute"} top={0} left={0} >
            <Box display={"flex"} flexDirection={"row"}>
                {/* Equipements */}
                <Box display={"flex"} flexDirection="column" marginRight={"25px"}>
                    <Box display={"flex"} flexDirection="row">
                        <DbKokiriSwordItem items={props.items} update={props.updateItem} />
                        <DbBiggoronSwordItem items={props.items} update={props.updateItem} />
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbHylianShieldItem items={props.items} update={props.updateItem} />
                        <DbMirrorShieldItem items={props.items} update={props.updateItem} />
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbGoronTunicItem items={props.items} update={props.updateItem} />
                        <DbZoraTunicItem items={props.items} update={props.updateItem} />
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbIronBootsItem items={props.items} update={props.updateItem} />
                        <DbHoverBootsItem items={props.items} update={props.updateItem} />
                    </Box>
                </Box>
                {/* Armes */}
                <Box display={"flex"} flexDirection="column" marginRight={"25px"}>
                    <Box display={"flex"} flexDirection="row">
                        <DbSlingshotItem items={props.items} update={props.updateItem} />
                        <DbBowItem items={props.items} update={props.updateItem} />
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbBoomrangItem items={props.items} update={props.updateItem} />
                        <DbHookshotItem items={props.items} update={props.updateItem} />
                        {/* <DbScaleItem items={props.items} update={props.updateItem} /> */}
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbBombItem items={props.items} update={props.updateItem} />
                        <DbMegatonHammerItem items={props.items} update={props.updateItem} />
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbBombchusItem items={props.items} update={props.updateItem} />

                    </Box>
                </Box>
                   {/* Armes Magiques */}
                   <Box display={"flex"} flexDirection="column" marginRight={"25px"}>
                    <Box display={"flex"} flexDirection="row">
                        <DbFireArrowItem items={props.items} update={props.updateItem} />
                        <DbIceArrowItem items={props.items} update={props.updateItem} />
                        <DbLightArrowItem items={props.items} update={props.updateItem} />
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbDinsFireItem items={props.items} update={props.updateItem} />
                        <DbFaroresWindItem items={props.items} update={props.updateItem} />
                        <DbLensOfTruthItem items={props.items} update={props.updateItem} />
                    </Box>
                    <Box display={"flex"} flexDirection="row" height={"15px"}>
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbScaleItem items={props.items} update={props.updateItem} />
                        <DbStrengthItem items={props.items} update={props.updateItem} />
                        <DbMagicItem items={props.items} update={props.updateItem} />

                    </Box>
                    <Box display={"flex"} flexDirection="row">
                        <DbWalletItem items={props.items} update={props.updateItem} />
                        <DbGerudoCardItem items={props.items} update={props.updateItem} />
                        <DbMagicBeansItem items={props.items} update={props.updateItem} />
                    </Box>
                    <Box display={"flex"} flexDirection="row" height={"32px"}>
                        <DbRutoLetterItem items={props.items} update={props.updateItem} />
                        <DbEmptyBottleItem items={props.items} update={props.updateItem} />
                        <DbAdultSequenceItem items={props.items} update={props.updateItem} />
                    </Box>
                </Box>
                 {/* Inventaire */}
                 <Box display={"flex"} flexDirection="column" marginRight={"25px"}>
                   
                    <Box display={"flex"} flexDirection="row">
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                    </Box>
                    <Box display={"flex"} flexDirection="row">
                    </Box>
                </Box>
            </Box>
            <Box display={"flex"} flexDirection={"row"}>
                <DbKokiriEmeraldItem items={props.items} update={props.updateItem} />
                <DbGoronRubyItem items={props.items} update={props.updateItem} />
                <DbZoraSapphireItem items={props.items} update={props.updateItem} />
                <DbLightMedallionItem items={props.items} update={props.updateItem} />
                <DbForestMedallionItem items={props.items} update={props.updateItem} />
                <DbFireMedallionItem items={props.items} update={props.updateItem} />
                <DbWaterMedallionItem items={props.items} update={props.updateItem} />
                <DbShadowMedallionItem items={props.items} update={props.updateItem} />
                <DbSpiritMedallionItem items={props.items} update={props.updateItem} />
            </Box>
        </Box>
    </Box>
}

export default CommentaryPlayerTracker